<template>
    <div>
        <div class="bg--img bg--brands-that-trust-us wash heavy">
            <div class="grid-container">
                <div class="grid-x grid-padding-x">
                    <div class="cell small-12">
                        <h1 class="pad-top--xl pad-bottom--xl z-up text-white">
                            {{ userName }} - My Profile
                        </h1>
                    </div>
                </div>
            </div>
        </div>
        <div class="grid-container">
            <div class="grid-x grid-padding-x border-bottom pad-top pad-bottom">
                <div class="cell small-12 medium-3">
                    <router-link
                        to="/profile/my-profile"
                        class="h4">
                        My Profile
                    </router-link>
                </div>
                <div class="cell small-12 medium-3">
                    <router-link
                        to="/profile/my-orders"
                        class="h4 text-light-grey">
                        My Orders
                    </router-link>
                </div>
                <div class="cell small-12 medium-3">
                    <router-link
                        to="/profile/my-designs"
                        class="h4 text-light-grey">
                        My Designs
                    </router-link>
                </div>
                <div class="cell small-12 medium-3">
                    <router-link
                        to="/profile/my-favourites"
                        class="h4 text-light-grey">
                        My Favourites
                    </router-link>
                </div>
            </div>
            <div class="grid-x grid-padding-x pad-top--large pad-bottom--xl">
                <div class="cell small-12">
                    <p class="lead">
                        Name: {{ userName }}<br />
                        Email: {{ userEmail }}<br />
                    </p>
                </div>
            </div>
            <div class="grid-x grid-padding-x pad-top--large pad-bottom--xl">
                <div class="cell small-12">
                    <button
                        v-on:click="logOut"
                        class="button tall">
                        Log Out
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'MyProfile',
    computed: {
        userName() {
            return this.$store.getters.userName;
        },
        userEmail() {
            return this.$store.getters.userEmail;
        },
    },
    methods: {
        logOut() {
            this.$store.dispatch('logout');
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/components/Profile/MyProfile.vue